import { schFilledAddress, schMainPropertyType } from '@aloft/toolkit-shared';

import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

export const schAddComparablesForm = z.strictObject({
  // Address validation cant rely on those minimum 1 character fields
  // because of the conflict between the controlled component issue
  // and the zod validation that automatically runs on form submit.
  address: schFilledAddress.omit({ CountyName: true }).optional(),
  propertyType: schMainPropertyType,
});
export type AddComparablesForm = z.infer<typeof schAddComparablesForm>;

export type AddCompsFormProps = {
  form: UseFormReturn<
    z.input<typeof schAddComparablesForm>,
    unknown,
    z.infer<typeof schAddComparablesForm>
  >;
};
